const NavigationActionTypes = {
  NAVIGATE: 'NAVIGATE',
  DASHBOARD: 'DASHBOARD',
  EVENTS: 'EVENTS',
  MEMBERS: 'MEMBERS',
}

const pageNamePathMap = {
  [NavigationActionTypes.DASHBOARD]: '',
  [NavigationActionTypes.EVENTS]: 'events',
  [NavigationActionTypes.MEMBERS]: 'members'
}

export { pageNamePathMap };

export default NavigationActionTypes;
